<div class="snack-bar-container">
    <span class="message">{{ data }}</span>
    <div class="snack-bar-actions">
        <div class="left-container">
            <button class="cancel-btn"(click)="onCancel()">Cancel</button>
        </div>
        <div class="right-container">
            <button class="proceed-btn" (click)="onSubmit()">Proceed</button>
        </div>
    </div>
</div>